<template>
  <svg viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.9791 30.4786C24.4104 31.0443 23.4922 31.0463 22.9211 30.4831V30.4831C22.3422 29.9122 22.3402 28.9786 22.9166 28.4052L27.3362 24.0089L13.5089 24.0089C12.6756 24.0089 12 23.3334 12 22.5V22.5C12 21.6666 12.6756 20.9911 13.5089 20.9911L27.3362 20.9911L22.9179 16.6033C22.3405 16.0299 22.3411 15.0958 22.9193 14.5231V14.5231C23.491 13.9569 24.4126 13.9578 24.9831 14.5254L32.2873 21.791C32.6803 22.182 32.6803 22.818 32.2873 23.209L24.9791 30.4786Z"
      fill="white"
    />
  </svg>
</template>
